"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useState } from "react";
import { useSocket } from "../hooks/useSocket.js";
export const ContactsContext = createContext(null);
export const ContactsProvider = ({ children, id, }) => {
    const { uri, socket } = useSocket();
    const [contactRequests, setContactRequests] = useState([]);
    const [acceptedContactRequests, setAcceptedContactRequests] = useState([]);
    const [groupsJoined, setGroupsJoined] = useState([]);
    useEffect(() => {
        if (!socket || !id)
            return;
        socket.emit("subscribe-requests", id);
        socket.on("contact-request", (data) => {
            setContactRequests((prev) => [...prev, data]);
        });
        socket.on("contact-request:accept", (data) => {
            setAcceptedContactRequests((prev) => [...prev, data]);
        });
        socket.on("new-group", (data) => {
            setGroupsJoined((prev) => [...prev, data]);
        });
    }, [socket, id]);
    if (!uri.includes("/contacts")) {
        throw new Error("ContactsProvider must be used within SocketProvider with a contacts uri");
    }
    return (_jsx(ContactsContext, { value: { id, contactRequests, acceptedContactRequests, groupsJoined }, children: children }));
};
